import React from 'react';
// import './fair-practice-code.css'; // Optional for custom styles
import Table from 'react-bootstrap/Table';
import "./terms-conditions.css";
import { Container } from 'react-bootstrap';

const FairPracticeCode = () => {
    return (
    <div className="tc-container">
      <header className="tc-header mb-3">
        <h1>Fair Practice Code</h1>
      </header>

      <section className="tc-content mb-3">
        <h2>INTRODUCTION:</h2>
        <p>
          
Singh Finlease Private Limited is a non-deposit taking Non-Banking Finance Company registered with Reserve Bank of India (“RBI”). The company is presently in the business of providing different types of loans which includes Personal Loans etc., to its various customers. Such credit facilities are extended to “Individual” types of customers. Singh Finlease Private Limited (“the Company”) has put in place the Fair PracƟces Code (“FPC”) as per the RBI guidelines and it has been duly approved by the Board of Directors. The FPC sets out the principles for fair practices, transparency & adequate disclosures while dealing with its customers. The commitments outlined in this FPC adopted by the company are applicable under normal operating environment; however, under situations beyond the control of the Company, it may not be possible for us to fulfil the commitments made thereunder.
        </p>
       <h2>1. KEY COMMITMENTS </h2>
       <p>a. Act fairly and reasonably in all dealings with customers.

        <li> Meet commitments and standards specified in the Code.</li>
        <li> Ensure compliance with applicable laws and regulations.</li>
        <li>Dealings will rest on integrity and transparency.</li>
       </p>

       <p>b. Act fairly and reasonably in all dealings with customers. <br />
       c. Handle grievances fairly and promptly. <br />
       d. Publicize the Code and make it available on request.</p>

       <h2> 2. INFORMATION</h2>
       <p> a. The Company shall help its customer choose products and services, which meet their needs and give them clear informaƟon explaining the key features of the services and products they are interested in . 

       <br />b. Inform customers about the documents and information the Company needs from them to establish customer’s true idenƟty and address and, other documents to comply with legal and regulatory requirements via-a`-vis extent “Know Your Customer” guidelines .
       </p>

       <h2> 3. APPLICATIONS FOR LOAN & THEIR PROCESSING </h2>
       <p>The company has a lending plaƞorm “Zest Cash” which is a mobile and web-based plaƞorm and a cuƫng-edge Fintech product which has been developed and designed to make individual’s personal financing needs easier and faster. Our customers can avail loan facility from us via this android based mobile application anytme, anywhere and the entire process starting from the registration – to - Loan Application - to - Application Processing - to - Loan disbursement directly to the bank account of the user, is completely online .
All communications to the borrower shall be in the vernacular language or a language as understood by the borrower.
The loan application forms of the Company include necessary information which affects the interest of the borrower, so that a meaningful comparison with the terms and conditions offered by other NBFCs can be made and informed decision can be taken by the borrower. The loan applicaƟon form indicates the documents required to be submitted with the application form.
It issues a written acknowledgement for each application after receipt of the complete informaƟon as per the standard application format. Additional information and support documents may occasionally be found necessary in course of processing a customer/borrower application.
Applications complete in all respects are processed within a reasonable time frame. In case the proposal is not approved by the Company, the borrower is informated accordingly. </p>

<h2> 4. LOAN APPRAISAL AND TERMS & CONDITIONS </h2>
       <p>Borrower is informed about the sanctioned amount, interest rate, and terms via SMS/email in an understandable language. Consent is recorded digitally. Penalties are mentioned in FAQ.

<br /> Multiple signing options like Aadhaar OTP, digital signature, checkbox consent are offered based on risk profile.</p>

<h2> 5. DISBURSEMENT OF LOANS INCLUDING CHANGES IN TERMS </h2>
       <p>a. Borrowers are notified of any changes in terms in advance.

<br /> b. Recall of payment will follow agreement terms.
<br /> c. Borrower must enter into an agreement before disbursement.</p>

<h2> 6. INTEREST RATE MODEL & RATE OF INTEREST CHARGES </h2>
       <p>Rates are based on various internal and market-linked factors.    

 <br /> a. Cost of borrowings
<br /> b. Operating cost and expected returns
<br /> c. Credit and default risk
<br /> d. Risk profile and customer creditworthiness
<br /> e. Market competition
<br /> f. Risk categorization of borrowers</p>

{/* 👇 Section 6.1 - Cost Factor Description Table */}
      <div className="mb-5">
        <h4 className="text-center fw-bold mb-4">Cost Factor Description Table</h4>
        <Table bordered responsive hover>
          <thead className="table-secondary">
            <tr>
              <th>Sr. No.</th>
              <th>Factor</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Weighted Average Cost of Borrowing</td>
              <td>Cost of funds borrowed privately.</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Fund Raising Cost</td>
              <td>Includes loan processing & brokerage fees.</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Opex Cost</td>
              <td>Operational costs like staff, marketing, etc.</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Risk Premium</td>
              <td>Business-related risk buffer.</td>
            </tr>
            <tr>
              <td>5</td>
              <td>Base ROA</td>
              <td>Minimum return expected by company.</td>
            </tr>
          </tbody>
        </Table>
      </div>

<h2> 7. GENERAL </h2>
       <p> a. Company will avoid interference in borrower affairs.
        <br /> b. Transfer of loan account requests handled within 21 days. 
        <br /> c. No harassment or unethical recovery practices allowed.
        <br /> d.  No foreclosure charges on floating rate loans for individuals.</p>

        <h2> 8. GRIEVANCE REDRESSAL MECHANISM </h2>
       <p> a. Grievance forum setup for dispute resolution.
        <br /> b. Periodic review of FPC and complaint handling. 
        <br /> c. Contact details of redressal officer displayed.
        <br /> d. If unresolved within 1 month, customer can approach RBI or NBFC Ombudsman.</p>

        <h2> 9. POSTING ON WEBSITE </h2>
       <p> FPC in a language understood by the borrower is posted on the website. </p>

       <h2> 10. Interest Policy </h2>
       <p> Zest Cash offers loans up to 36% p.a. starting from ₹1500, with no hidden fees. Flexible repayment and transparent processing. </p>

       <h3 className="text-center mb-4">Loan Charges Details</h3>
      <Table striped bordered hover responsive>
        <thead className="table-secondary">
          <tr>
            <th>Type of Charge</th>
            <th>Charge % / INR</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Processing Fee</td>
            <td>Starts from ₹1500</td>
          </tr>
          <tr>
            <td>Loan Foreclosure / Pre-payment</td>
            <td>₹0</td>
          </tr>
          <tr>
            <td>Additional Processing Fee</td>
            <td>15% of Loan amount</td>
          </tr>
          <tr>
            <td>GST</td>
            <td>18% of Processing Fee</td>
          </tr>
          <tr>
            <td>Rate of Interest</td>
            <td>Up to 270% p.a. (0% for 30-day loan)</td>
          </tr>
          <tr>
            <td>Bounce Charges</td>
            <td>₹0</td>
          </tr>
          <tr>
            <td>Late Payment Penalty</td>
            <td>Up to 0.75%/day</td>
          </tr>
          <tr>
            <td>Stamp Duty</td>
            <td>As per law</td>
          </tr>
          <tr>
            <td>Duplicate NOC</td>
            <td>₹0</td>
          </tr>
          <tr>
            <td>Instrument Swapping</td>
            <td>₹0</td>
          </tr>
          <tr>
            <td>Loan Cancellation</td>
            <td>₹0</td>
          </tr>
          <tr>
            <td>Loan Re-booking</td>
            <td>₹0</td>
          </tr>
          <tr>
            <td>Statement of Account</td>
            <td>₹0</td>
          </tr>
          <tr>
            <td>Duplicate Repayment Schedule</td>
            <td>₹0</td>
          </tr>
          <tr>
            <td>Bounce Charges (Self Employed)</td>
            <td>₹0</td>
          </tr>
        </tbody>
      </Table>
      </section>
    </div>
  );
};

export default FairPracticeCode;
